var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14.64 14.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Checkbox") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.62.5l10.17.58c2.76 0 1.6 1.66 1.6 4.42v2.87c0 2.76 1.15 5-1.6 5H1.97c-2.76 0-1.82-2.24-1.82-5V5.5c0-2.76-.3-5 2.46-5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.46 3.87a28.94 28.94 0 0 0-.28-3.22.42.42 0 0 0-.38-.4c-1.16 0-2.3.28-3.45.18A25 25 0 0 0 7.5 0C5.24 0 2.95.25.7.25.46.25.3.5.24.75a.5.5 0 0 0-.13.33c0 2.77 0 5.53.1 8.3.04 1.18-.34 3.77 1 4.5a6.27 6.27 0 0 0 2.07.38 14.72 14.72 0 0 0 3.25 0c2.4-.33 4.8 0 7.22-.28a.57.57 0 0 0 .5-.52c.08-2.24-.33-4.46-.1-6.7.13-.98.3-1.93.32-2.9zM8 13a21.45 21.45 0 0 1-5.42.15c-.78-.1-1.16-.07-1.4-1a4.42 4.42 0 0 1 0-1c-.04-1.13-.1-2.26-.1-3.37 0-2.2 0-4.35 0-6.54C3.17 1.24 5.3 1 7.42 1c1 .1 1.94.25 2.9.44a20.38 20.38 0 0 0 3.12-.15 18.5 18.5 0 0 1 .22 2.33c0 1.2-.25 2.4-.32 3.57-.13 1.92.15 3.8.15 5.72-1.9.14-3.7-.14-5.5.08z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.1aa5c8d3adb3bf02509c4b9c3dbb2674.svg";
export { ForwardRef as ReactComponent };